import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {ReactComponent as Circle} from "../../assets/circle.inline.svg";
import {ReactComponent as Triangle} from "../../assets/triangle.inline.svg";
import {ReactComponent as QuarterCircle} from "../../assets/quarterCircle.inline.svg";
import {ReactComponent as Square} from "../../assets/square.inline.svg";
import {ReactComponent as ReverseQuarterCircle} from "../../assets/reverse-quarter.inline.svg";
import {ReactComponent as Star} from "../../assets/star.inline.svg";
import {ReactComponent as Bubble} from "../../assets/bubble.inline.svg";
import {ReactComponent as CurvyDiagonal} from "../../assets/curvy-diagonal.inline.svg";
import {ReactComponent as Diamond} from "../../assets/diamond.inline.svg";
import {ReactComponent as QuarterStar} from "../../assets/quarter-star.inline.svg";
import {ReactComponent as StarOne} from "../../assets/star-one.inline.svg";
import {ReactComponent as StarTwo} from "../../assets/star-two.inline.svg";




function ShapeSwitch({shapeId}) {
  const [ shape, setShape ] = useState( null );
  useEffect(() => {
    switch (shapeId) {
      case "circle":
        setShape(<Circle/>);
        break;
      case "triangle":
        setShape(<Triangle/>);
        break;
      case "quarterCircle":
        setShape(<QuarterCircle/>);
        break;
      case "square":
        setShape(<Square/>);
        break;
      case "reverseQuarterCircle":
        setShape(<ReverseQuarterCircle/>);
        break;
      case "star":
        setShape(<Star/>);
        break;
      case "bubble":
        setShape(<Bubble/>);
        break;
      case "curvyDiagonal":
        setShape(<CurvyDiagonal/>);
        break;
      case "diamond":
        setShape(<Diamond/>);
        break;
      case "quarterStar":
        setShape(<QuarterStar/>);
        break;
      case "starOne":
        setShape(<StarOne/>);
        break;
      case "starTwo":
        setShape(<StarTwo/>);
        break;
      default:
        setShape(null);
        break;
    }
  }, [shapeId]);
  return shape
}

ShapeSwitch.propTypes = {
  shapeId: PropTypes.string.isRequired,
};

export default ShapeSwitch;